import { connect } from "react-redux";
import { getActiveDocumentId, getCalculatedDetailedPanelOpen, getProjectId, getUpdatesNeural } from "../redux/selectors";
import NeuralInterface from "./NeuralInterface";
import { getActiveDocumentType, getIsExpanded, getMethods } from "Areas/Sidebar/Documents/redux/selectors";
import { InProgressFileSave, neuralInterfaceActionCreators } from "./redux";
import graphActionCreators from "Areas/Documents/graph/redux/actionCreators";
import { actionCreators } from "Areas/Sidebar/DocumentsFloat/redux";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { createRecord } from "Utils";
const mapStateToProps = (state) => ({
    documentId: getActiveDocumentId(state),
    activeDocumentType: getActiveDocumentType(state),
    methods: createRecord(getMethods(state), "Id"),
    projectId: getProjectId(state),
    isOpenRightPanel: getCalculatedDetailedPanelOpen(state),
    isOpenLeftPanel: getIsExpanded(state),
    saveFileInProgress: InProgressFileSave(state),
    updatesNeural: getUpdatesNeural(state)
});
const mapDispatchToProps = (dispatch) => ({
    saveFIle(data, onCompleted) {
        dispatch(neuralInterfaceActionCreators.saveFile({ data, onCompleted }));
    },
    voiceRecognize(data, onCompleted) {
        dispatch(neuralInterfaceActionCreators.voiceRecognition({ data, onCompleted }));
    },
    onRunMethods: (documentId, activeDocumentType, data) => {
        const action = actionCreators.runMethods(documentId, data);
        if (action) {
            if (activeDocumentType === DOCUMENT_TYPE.GRAPH) {
                dispatch(graphActionCreators.setSaveTriggered(documentId, true));
            }
            dispatch(action);
        }
    },
    onInitialized: () => {
        dispatch(actionCreators.getMethods());
        dispatch(actionCreators.getObjects());
    },
    onClearUpdates: (documentId, nodesSourceUpdateRecordIds, edgesSourceUpdateRecordIds) => dispatch(graphActionCreators.clearFromUpdates(documentId, nodesSourceUpdateRecordIds, edgesSourceUpdateRecordIds))
});
export default connect(mapStateToProps, mapDispatchToProps)(NeuralInterface);
